import { useCallback } from 'react'
import { useRouter } from 'next/router'

import { useBucket } from '@mc/experiments-react'
import { paths } from '@mc/paths'
import { trackExperimentViewed } from '@mc/track-event'

import { QR_SEALED_BUCKET_V1_EXP_NAME } from '../utils'

export const useQRSealedBucketV1Experiment = () => {
  const bucket = useBucket(QR_SEALED_BUCKET_V1_EXP_NAME)
  const { asPath } = useRouter()
  const isInQuizPage = asPath.includes(paths.classRecommendations)
  const isQRSealedBucketV1Variant =
    bucket?.startsWith('variant') && isInQuizPage

  const trackQRSealedBucketV1Viewed = useCallback(() => {
    trackExperimentViewed(QR_SEALED_BUCKET_V1_EXP_NAME)
  }, [])

  return { isQRSealedBucketV1Variant, trackQRSealedBucketV1Viewed }
}
